<!-- original template: /Website/Views/Content/OffersList/Partials/_OffersListItem.cshtml -->
<template>
  <article class="offer-list-item" :data-hotelcode="offer.Merlin_HotelCode">
    <div class="offer-list-item__media">
      <div v-if="!offer.isNew && offer.Hotel_Features && ratingMoreThanZero" class="offer-list-item__rating">
        <strong>{{ offer.Hotel_AverageRating }}</strong> / 6
      </div>
      <div v-if="offer.isNew" class="offer-list-item__newOffer">
        Nowość
      </div>

      <div class="offer-list-item__image" :data-href="offer.Hotel_Id">
        <div class="offer-list-item__image-hover" @click="visibleHotelGallery = offer.id">
          <p><span class="custom-icon--camera" /></p>
          <p>Zobacz więcej zdjęć</p>
        </div>
        <img loading="lazy" :src="`${offer.Hotel_ListingImageUrl}?h=240`" :alt="offer.Hotel_Name">
      </div>

      <div class="offer-list-item__labels">
        <div v-for="label in offer.labels" :key="label.id"
          class="offer-list-item__label" :style="{ backgroundColor: label.color }">
          {{ label.name }}
        </div>
      </div>
    </div>

    <div class="offer-list-item__content">
      <div class="offer-list-item__hotel-location">
        <span class="span_underline">
          <a :href="offer.Hotel_Location_Name">{{ offer.Hotel_Location_Name }}</a> / {{ offer.Merlin_City }}
        </span>
      </div>

      <div class="offer-list-item__hotel-type">
        <span class="offer-list-item__hotel-category">{{ offer.Hotel_Type_Name }} / {{ offer.Hotel_TextCategory }}</span>
        <a :href="offer.url" target="_blank">
          <span class="offer-list-item__hotel-name">{{ offer.Hotel_Name }}</span>
          <span :class="[ 'stars', 'stars--lightblue', offer.Hotel_Standard_Stars_Css, 'offer-list-item__hotel-standard' ]" />
        </a>
        <div class="hotel-category-info">
            <span class="offer-list-item__hotel_local-category">KATEGORIA LOKALNA: </span>
            <span v-if="offer.Hotel_LocalStandard == 'keys'" :class="[ 'keys', offer.Hotel_Keys_Value, 'offer-list-item__hotel-standard' ]" />
            <span v-else :class="[ 'stars-local', 'stars--grey', offer.Hotel_Local_Standard_Stars_Css, 'offer-list-item__hotel-standard' ]" />
        </div>
      </div>

      <div class="offer-list-item__info-wrapper">
        <ul class="offer-list-item__hotel-info">
          <li v-for="highlight in offer.highlights" :key="highlight.id">
            <span class="custom-icon--tick-darkblue" />
            {{ highlight.name }}
          </li>
        </ul>

        <ul class="offer-list-item__offer-info">
          <li>
            <span class="custom-icon--calendar" />
            <span>{{ offer.Merlin_ParsedStartFullDate }} / {{ offer.Merlin_Duration }} dni</span>
          </li>
          <li class="offer-tooltip" data-ct-nowrap data-ct-load data-ct-airports>
            <div class="offer-tooltip__wrapper">
              <span class="custom-icon--plane icon-arrow" />
              <span>{{ offer.Merlin_FlightFrom }} / {{ offer.Merlin_ParsedDepartureTime || '' }}</span>
              <Tooltip :isDynamic="true" @load="loadDepartureAirports">
                <template slot-scope="{ data }">
                  <span class="custom-icon--info" />
                  <p>Opcje wylotów</p>
                  <ul v-if="data != null">
                    <li v-for="airport in data.airports" :key="airport.id">{{ airport.name }}</li>
                  </ul>
                </template>
              </Tooltip>
            </div>
          </li>
          <li class="offer-tooltip" data-ct-nowrap data-ct-load data-ct-alimentation>
            <div class="offer-tooltip__wrapper">
              <span class="custom-icon--kettles icon-arrow" />
              <span class="content">{{ offer.Merlin_BoardStandardDesc }}</span>
            </div>
          </li>
        </ul>
        <div class="offer-list-item__price">
          <div v-if="offer.Merlin_OfferTypeSitecore" class="offer-list-item__price-promo">
            <span class="offer-list-item__price-promo-label" :style="{ color: offer.Merlin_OfferTypeSitecore.Color }">
              {{ offer.Merlin_OfferTypeSitecore.Name }}
            </span>
            <span class="offer-list-item__price-promo-icon" :style="{ background: offer.Merlin_OfferTypeSitecore.Color }">
              {{ offer.Merlin_OfferTypeSitecore.ShortName }}
            </span>
          </div>
          <div>
            <span v-if="priceType == 'person'" class="offer-list-item__price-value">{{ offer.Merlin_AdultPrice }}</span>
            <span v-if="priceType == 'group'" class="offer-list-item__price-value">{{ offer.Merlin_FullPriceParsed }}</span>
            <span class="offer-list-item__price-currency">zł</span>
          </div>
          <div class="offer-list-item__price-type">
            Cena kompletna
            <span v-if="priceType == 'person'"> / 1 Os</span>
          </div>
          <div>
            <a class="btn-cta btn-cta--arrow btn-cta--fill btn-cta--lightblue offer-list-item__show-offer"
              :href="offer.url" target="_blank"
              :title ="offer.Hotel_Name"
              @click="redirectToOffer(offer)"
            >
              Zobacz ofertę
            </a>
          </div>
          <div>
            <button class="offer-list-item__other-termines-and-prices"
              :data-href="offer.Merlin_HotelCode"
              :data-offer="offer.Merlin_Id"
              @click="visibleOtherTermins = offer.id">
              Inne terminy i ceny
            </button>
          </div>
        </div>
        <div class="offer-list-item__brands">
          <div v-for="(brand, index) in offer.Hotel_SubBrands" :key="index" v-if="brand.Grey_Logo_Src" class="offer-list-item__brand">
            <div class="offer-list-item__brand-tooltip">
              <div class="offer-list-item__brand-title">{{ brand.Amenities_Name }}</div>
              <div class="offer-list-item__brand-description" v-html="brand.Description" />
            </div>
            <img class="offer-list-item__brand-icon" :src="brand.Grey_Logo_Src">
          </div>
        </div>
      </div>
    </div>

    <!-- modals -->
    <GalleryModal v-if="visibleHotelGallery == offer.id" :offer="offer" @close="visibleHotelGallery = null" />
    <OtherTerminsAndPricesModal v-if="visibleOtherTermins == offer.id"
      :objectId="offer.Merlin_HotelCode"
      @close="visibleOtherTermins = null"
    />
  </article>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import GalleryModal from './GalleryModal'
import OtherTerminsAndPricesModal from './OtherTerminsAndPricesModal'
import Tooltip from './Tooltip'

import Icon from '@/components/Icon'
import { API } from '@/modules/api'
import { DataLayerEvent, pushEvent } from '@/modules/datalayer/helpers'

@Component({
  components: {
    Icon,
    Tooltip,
    GalleryModal,
    OtherTerminsAndPricesModal,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
    priceType: {
      type: String, // 'person' or 'group'
      required: false,
      default: () => 'person',
    },
  },
})
export default class Offer extends Vue {
  visibleHotelGallery = null
  visibleOtherTermins = null
  ratingMoreThanZero = parseInt(this.offer.Hotel_AverageRating) > 0

  get wffmForm () {
    return document.querySelector('.offer-search-advanced')
  }

  redirectToOffer (offer) {
    /* eslint-disable */
    const eventItems = offer
      ? [offer].map((item, idx) => ({
          item_name: item["Hotel_Name"],
          item_id: item["Hotel_Id"],
          price: item["Merlin_AdultPrice"],
          item_category: item["Hotel_TextCategory"],
          index: idx,
          hotel_type: item["Merlin_BoardStandardDesc"],
          hotel_id: item["Merlin_HotelCode"],
          departure_date: item["Merlin_ParsedStartFullDate"],
          duration: item["Merlin_Duration"],
          hotel_standard: item["Hotel_Local_Standard_Stars_Css"],
          offer_type: item["Merlin_OfferTypeSitecore"]
            ? item["Merlin_OfferTypeSitecore"].Name
            : null,
        }))
      : [];
    const [event] = DataLayerEvent.itemList("select_item", eventItems);
    event.ecommerce.item_list_name =
      window.location.origin + window.location.pathname;
    pushEvent(event);
    /* eslint-enable */
  }

  loadDepartureAirports (done) {
    new API().getOfferAirports(this.offer.Merlin_HotelCode).then(done)
  }
  loadBoardTypes (done) {
    new API().getOfferFoods(this.offer.Merlin_HotelCode).then(done)
  }
  loadHotelPhotos (done) {
    new API().getHotelPictures(this.offer.Hotel_Id).then(done)
  }
}
</script>

<style lang="scss">
.offer-list-item {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  text-transform: uppercase;
  margin-top: 15px;

  @include media(tablet) {
    flex-direction: row;
  }

  &__newOffer {
    position: absolute;
    top: 10px;
    left: 17px;
    font-weight: 700;
    font-size: 11px;
    background-color: #E71F6C;
    font-family: 'Gotham';
    text-align: center;
    padding: 7px 9px 6px;
    color: #fff;
    text-transform: uppercase;
    z-index: 2;

    @include media(tablet) {
      top: 11px;
      left: 11px;
    }

    @include media(desktop) {
      font-size: 12px;
    }
  }

  &__rating {
    position: absolute;
    top: 15px;
    left: 14px;
    color: white;
    background-color: #005ca9;
    padding: 5px 8px;
    font-family: Gotham Book;
    font-weight: 400;
    font-style: normal;
    font-size: 1.5rem;
    z-index: 2;

    strong {
      font-size: 1.7rem;
    }
  }

  &__image {
    text-align: center;
    height: 200px;
    overflow: hidden;
    position: relative;

    @include media(tablet) {
      width: 190px;
      height: 100%;
    }
    @include media(desktop) {
      width: 320px;
    }

    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__image-hover {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: #005ca9;
    color: white;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 400;
    font-family: Gotham Book;
    z-index: 2;

    p {
      margin-bottom: 0;
    }

    &:hover {
      opacity: 0.9;

      p {
        opacity: 1;
      }
    }
  }

  &__labels {
    position: absolute;
    bottom: 15px;
    right: -3px;
  }

  &__label {
    color: #fff;
    text-transform: uppercase;
    font-size: 10px;
    font-family: 'Gotham';
    font-weight: 700;
    font-style: normal;
    text-align: center;
    margin: .5px 0;  
    padding: 4px 10px 3px;
    float: right;
    clear: both;

    @include media(desktop) {
      padding: 5px 10px 4px;
    }
  }

  &__media {
    position: relative;
  }

  &__content {
    width: 100%;
    min-height: 200px;
    padding: 5px 15px 15px 15px;

    @include media(tablet) {
      width: calc(100% - 190px);
      min-height: auto;
    }
    @include media(desktop) {
      padding: 15px 20px 20px;
    }
  }

  &__hotel-location {
    margin-bottom: 6px;

    .span_underline {
      font-family: "Gotham Book";
      font-weight: normal;
    }

    a {
      color: #005ca9;
      text-decoration: none;
      font-family: "Gotham";
      font-weight: bold;
    }
  }

  &__hotel-type {
    color: #787878;
    margin-bottom: 14px;

    a {
      display: block;
      color: #535353;
      text-decoration: none;
      font-size: 13px;
      font-weight: 700;
      line-height: 12.3px;
    }
  }

  &__hotel-category {
    font-family: 'Gotham Book';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
  }

  &__hotel-name {
    font-size: 13px;
  }

  &__hotel_local-category {
      font-size: 10px
  }

  &__hotel-standard {
    display: inline-block;
    color: #009fea;
    font-size: 13px;
    line-height: 21px;
    margin-top: 1px;
    vertical-align: bottom;
  }

  &__info-wrapper {
    display: flex;
    position: relative;
  }

  &__offer-info,
  &__hotel-info {
    list-style: none;
    padding-left: 0;
    font-family: Gotham Book;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;

    li {
      padding: 5px 0;
      text-transform: none;
      text-overflow: ellipsis;
      overflow: visible;
    }

    [class^=custom-icon--] {
      color: #005ca9;
      margin-right: 3px;
      font-size: 16px;
      width: 10px;
      vertical-align: middle;
    }

    .custom-icon--arrow-top {
      display: none;

      @include media(tablet) {
        display: inline-block;
        cursor: pointer;
      }
    }
  }

  &__hotel-info {
    display: none;

    @include media(tablet) {
      display: block;
      width: 184px;
      margin-bottom: 20px;
    }
    @include media(desktop) {
      width: 380px;
    }

    li {
      padding-left: 16px;
      padding-right: 2px;

      span {
        position: absolute;
        margin-left: -16px;
        margin-top: -2px;
      }
    }
  }

  &__content-wrapper {
    display: flex;
    position: relative;
  }

  &__brands {
    position: absolute;
    bottom: 0;
    width: 132px;
    
    @include media(tablet) {
      width: 150px;
    }

    @include media(desktop) {
      width: auto;
    }
  }
  &__brand {
    display: inline-block;
    width: calc(100% / 3);

    @include media(desktop) {
      width: auto;

      &:hover &-tooltip {
        display: block;
      }
    }
  }
  &__brand-tooltip {
    position: absolute;
    display: none;
    width: 230px;
    padding: 10px;
    background: #fff;
    border: 0;
    min-height: 110px;
    margin-top: -125px;
    margin-left: -90px;
    bottom: 32px;
    z-index: 99;
    box-shadow: 0 0 20px 0 rgba(0,0,0,.3);

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 100%;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 10px 10px 0;
      border-color: #fff transparent transparent;
      left: 50%;
      margin-left: -10px;
    }
  }
  &__brand-title {
    text-transform: uppercase;
    font-size: 13px;
    font-size: 1.3rem;
    font-weight: 700;
    color: #005ca9;
  }
  &__brand-description {
    margin-top: 5px;
    font-size: 11px;
    font-size: 1.1rem;
    font-family: 'Gotham Book';
    overflow: hidden;
    width: auto;
    text-align: justify;
    text-transform: none;
  }

  &__brand-icon {
    width: 100%;

    @include media(desktop) {
      width: auto;
    }
  }

  &__price {
    font-family: 'Gotham';
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 2px;
    
    @include media(tablet) {
      flex: 1 0 auto;
      margin: 0;
    }

    @include media(desktop) {
      margin: -25px auto 0;
    }
  }

  &__price-promo {
    margin-bottom: -7px;
  }

  &__price-promo-label {
    color: #e71f6c;
    line-height: 1.8em;
    font-weight: 700;
    font-style: normal;
    font-size: 1rem;
  }

  &__price-promo-icon {
    width: 27px;
    height: 27px;
    border-radius: 15px;
    font-size: 10px;
    padding: 7px;
    background-color: #e71f6c;
    display: inline-block;
    color: white;
  }

  &__price-value {
    display: inline-block;
    font-size: 2.9rem;
    font-weight: 700;
    line-height: normal;
    color: #005ca9;
  }

  &__price-currency {
    font-size: 1.1rem;
    font-weight: 500;
    margin-left: -3px;
    color: #005ca9;
  }

  &__price-type {
    font-size: 8px;
    font-weight: 500;
    line-height: 16.8px;
    color: #787878;
  }

  &__show-offer {
    margin: 10px -20px 2px 0px;
    width: 150px;

    @include media(tablet) {
      margin: 3px auto;
    }
    @include media(desktop) {
      margin: 8px 0;
    }
  }

  &__other-termines-and-prices {
    display: none;
    font-size: .9rem;
    text-transform: uppercase;
    font-family: 'Gotham';
    font-weight: 500;
    font-style: normal;
    padding: 0;
    cursor: pointer;
    border: none;
    border-bottom: 1px solid hsla(0,0%,47%,.3);
    line-height: 1.1;
    background-color: transparent;
    color: #787878;
    outline: none;

    @include media(tablet) {
      display: inline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/Offer.vue